import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Observable, catchError, of, timer, switchMap } from 'rxjs';
import { Quote } from './models';

@Injectable({ providedIn: 'root' })
export class MarketService {
  private readonly http = inject(HttpClient);
  readonly quotes = signal<Quote[]>([]);
  readonly loading = signal(true);
  readonly offline = signal(false);

  constructor() {
    timer(0, 2500)
      .pipe(switchMap(() => this.http.get<Quote[]>('/api/markets').pipe(catchError(() => of(null)))))
      .subscribe((quotes) => {
        this.loading.set(false);
        if (quotes === null) {
          this.offline.set(this.quotes().length === 0);
          return;
        }
        this.offline.set(false);
        this.quotes.set(quotes);
      });
  }

  find(symbol: string): Quote | undefined {
    return this.quotes().find((quote) => quote.symbol === symbol);
  }

  detail(symbol: string): Observable<import('./models').MarketDetail> {
    return this.http.get<import('./models').MarketDetail>(`/api/markets/${symbol}`);
  }
}
